import { Box } from "@mui/material";
import type { FC } from "react";
import { FONT_SIZE, INK } from "../../../theme/tokens";
import { EyebrowLabel } from "../../UIToolkit/molecules/EyebrowLabel";

type Props = {
	/** Already translated: "What applying does". */
	heading: string;
	/** Already translated, one line each. */
	lines: readonly string[];
};

/** "What applying does" / "What deleting does": what the action changes on the schedule. */
export const HolidayEffectsList: FC<Props> = ({ heading, lines }) => (
	<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
		<EyebrowLabel component="h3">{heading}</EyebrowLabel>
		<Box component="ul" sx={{ m: 0, pl: 2.5, display: "flex", flexDirection: "column", gap: 0.75, color: INK.SECONDARY, fontSize: FONT_SIZE.EMPHASIS }}>
			{lines.map((line) => (
				<li key={line}>{line}</li>
			))}
		</Box>
	</Box>
);
